export default "__VITE_ASSET__G_SqOQzM__"